__turbopack_context__.v({
  "icon": "CustomDragPreview-module__YZ9IaG__icon",
  "label": "CustomDragPreview-module__YZ9IaG__label",
  "root": "CustomDragPreview-module__YZ9IaG__root",
});
